export default __webpack_public_path__ + "static/media/instant-rebate.f25a2f24.svg";